export const ADMIN = "RTW-Admins";
export const SMES = "RTW-SMES";
export const FC_LEADERS = "RTW-FC-LEADERS";
export const REQUESTER = "RTW-REQUESTERS";
export const DEV = "workingwell-engineer";
export const DLS = "rtw2-dls-users-us";
export const REGIONAL_VIEWER = "rtw2-regional-viewers-us";
